module.exports = __webpack_public_path__ + "img/t1.4d89cecf.jpg";